import React, { useState } from "react";
import { getDocs, collection, deleteDoc, doc } from "firebase/firestore";
import { db } from "../firebaseconfig/firebase";
import { Link, useNavigate } from "react-router-dom";
// import { MdDelete } from "react-icons/md";
import Loader from "../components/loader";

const Home = ({ isAuth }) => {
  const [postList, setPostList] = React.useState([]);
  const [active, setActive] = useState("All");
  const [loading, setLoading] = useState(true);

  const postCollectionRef = collection(db, "Posts");
  const navigate = useNavigate();
  // const deletePost = async (id) => {
  //   const postdoc = doc(db, "Posts", id);
  //   await deleteDoc(postdoc);
  // };

  //   React.useEffect(()=>{
  //     if(!isAuth){
  //         navigate("/");
  //     }
  // })

  const getPostList = async () => {
    try {
      const data = await getDocs(postCollectionRef);
      setPostList(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    } catch (error) {
      console.error("Error fetching posts: ", error);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    getPostList();
  });

  React.useEffect(() => {
    const getPost = async (id) => {
      const data = await getDocs(postCollectionRef);
      setPostList(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
      // console.log(data.docs.map((doc) => ({...doc.data(), id: doc.id})));
    };
    if (!isAuth) {
      navigate("/");
    }
    getPost();
  });

  const categories = [
    "All",
    "Technology",
    "Design",
    "Business",
    "Culture",
    "Lifestyle",
    "Religion",
    "Art",
    "Fashion",
    "News",
    "School",
  ];

  const filteredPosts =
    active === "All"
      ? postList
      : postList.filter((post) => post.category === active);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="bg-blue-950 min-h-screen">
      <div className="flex flex-wrap items-center gap-3 p-3 ml-8 border-b border-gray-200 dark:border-[#232f48] mb-4 overflow-x-auto">
        {categories.map((cat) => (
          <button
            key={cat}
            onClick={() => setActive(cat)}
            className={`px-4 py-1.5 rounded-full font-medium text-sm transition shadow-sm
            ${
              active === cat
                ? "bg-blue-600 text-white hover:bg-blue-700"
                : "bg-gray-700 text-2xl text-white dark:bg-gray-700 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600"
            }
          `}
          >
            {cat}
          </button>
        ))}
      </div>
        <div className="flex flex-col lg:flex-row flex-wrap justify-center gap-6 p-6 md:p-0">
          {filteredPosts.length > 0 ? (
            filteredPosts.map((post) => (
              <div
                key={post.id}
                className="w-full max-w-[700px] lg:w-[700px] rounded-xl"
              >
                <div className="border-2 p-4 border-gray-400 rounded-xl flex flex-col lg:flex-row gap-4 mb-6">
                  <div className="flex flex-col lg:w-[50%] pr-0 lg:pr-8">
                    <p className="text-blue-600 font-bold text-2xl">
                      {post.category || "null"}
                    </p>

                    <h4 className="text-xl font-semibold">
                      <Link
                        className=" text-white"
                        to={`/blogdescription/${post.id}`}
                      >
                        {post.title}
                      </Link>
                    </h4>

                    <p className="mt-3 text-gray-100">
                      {(
                        post.postDescription?.substring(0, 50) ||
                        "No description available"
                      ).trim()}
                      ...
                    </p>

                    <div className="flex flex-wrap gap-2 text-gray-100 text-sm mt-2">
                      <span>
                        By:{" "}
                        <span className="font-medium text-gray-100">
                          {post?.author.name || "Anonymous"}
                        </span>
                      </span>
                      <span>•</span>
                      <span>Published on {post?.date}</span>
                    </div>
                  </div>

                  <img
                    src={post.thumbnail}
                    alt={post.title}
                    className="w-full rounded-2xl object-cover lg:max-w-xs lg:h-[350px] h-[350px]"
                  />
                </div>
              </div>
            ))
          ) : (
            <p className="text-gray-500 text-lg mt-10">
              No posts found in this category.
            </p>
          )}
        </div>
    </div>
  );
};

export default Home;

